export const LOGIN_PATH = '/login';
export const HOME_PATH = '/home';